import React, {Component} from 'react';
import {connect} from "react-redux";
import {browserHistory} from "react-router";
import _ from 'i18n';
import {createCardRegistration, getToken, cardWebPayin, mangoPayCallback} from 'thunks';
import {Input, Button, notification, Row, Col} from 'antd';
import IBAN from 'iban';
import {PSPID, OGONE_URL, TTP_PAYMENT_URL} from 'Config';
import { TTP_API_URL, client_id, server_url } from 'Config';
import mangoPay from 'mangopay-cardregistration-js-kit';
import {showSpinner} from "../../../actions/actions/mangoPay";
import valid from 'card-validator'
import moment from "moment/moment";
import {expirationDate} from "card-validator/dist/expiration-date";
import { Radio } from 'antd';
import { Checkbox } from 'antd';
import {
  cardRegistrationForOrganization,
  FeedMangoWalletForOrganizationPayIn, mangoPayCallbackForOrganization
} from "../../../actions/thunks/mangoPay";



const ibantools = require('ibantools');


const openNotificationWithIcon = (type, description, message) => {
  notification[type]({
    message: message,
    description:
    description,
    style: {
      marginTop: 120,
    },
  });
};


const type = {
  v4: {
    httpsUrl: "https://api.ipify.org/"
  },
  v6: {
    httpsUrl: "https://api6.ipify.org/"
  }
};

class CardRegistration extends Component {

  constructor(props) {
    super(props);
    this.state = {
      CardNumber: "",
      dateExpiration : "",
      CVC: "",
      isCardNumberValid: true,
      isDateExpirationValid: true,
      isCvvValid: true,
      userCardType: "",
      value: "CB_VISA_MASTERCARD",
      checkedRegistrCard : true,
      pathImageLogo : "",
      ipAdress : "",
      try: 5,

    };

    this.originalState = {
      originalBic : " ",
      originalIban : " ",
    };

  }

  componentWillMount() {

    // this.props.createCardRegistration(this.props.orderId)

  }

  async componentDidMount() {
    this.setState({ipAdress : await this.getIp("v4") || JSON.parse(await this.getIpJsonTest())['ip']})
  }

  async getIp (version)  {
    const data = type[version];
    try {
      const response = await fetch(data.httpsUrl);
      const ip = response.text();
      return ip;
    } catch (e) {
      if(this.state.try > 0) {
        this.setState({try : this.state.try-1})
        return await this.getIp(version)
      }
      return null;
    }
  };

  async getIpJsonTest ()  {
    try {
      const response = await fetch("http://ip.jsontest.com/");
      const ip = response.text();
      return ip;
    } catch (e) {
      return null;
    }
  };

  handleCardNumberInputChange(value) {
    this.setState({CardNumber: value.trim()});
    var numberValidation = valid.number(value);
    if (numberValidation.card) {
      this.setState({isCardNumberValid: true});
      this.setState({userCardType: numberValidation.card.type});
      if(numberValidation.card.type == "visa") {
        this.setState({pathImageLogo: "/img/icons/visa.svg"});
      }

      else if (numberValidation.card.type == "mastercard") {
        this.setState({pathImageLogo: "/img/icons/mastercard (1).svg"});
      }

      else if (numberValidation.card.type == "maestro") {
        this.setState({pathImageLogo: "/img/icons/maestro (2).svg"});
      } else {
        this.setState({pathImageLogo: ""});
      }
    } else {
      this.setState({pathImageLogo: ""});
    }
  }

  handleCSVInputChange(v) {
    this.setState({CVC: v.trim()});

    let cvvValidation = valid.cvv(v);

    if(cvvValidation.isValid)
    {
      this.setState({isCvvValid: true});
    }

  }

  handleDateExpirationInputChange(value) {
    let regex = /[0-9][0-9]/g;
    let found = value.match(regex);

    let newValue = value;

    if(found && value.length == 2) {
      // newValue = value+"/"
    }

    if(value.length > 2 && value.substr(2, 1) !== "/") {
      newValue = value.substr(0, 2)+"/"+value.substr(2)
    }

    this.setState({dateExpiration: newValue.trim()});

    var dateExpirationValidation = valid.expirationDate(newValue);

    if (dateExpirationValidation.isValid) {
      this.setState({isDateExpirationValid: true});
    }
  }

  onBlurInput = () =>{

    var dateExpirationValidation = valid.expirationDate(this.state.dateExpiration);

    if(this.state.dateExpiration.length < 5) {
      this.setState({isDateExpirationValid: false});

    } else {
      if (!dateExpirationValidation.isPotentiallyValid) {
        this.setState({isDateExpirationValid: false});
      }

      if (dateExpirationValidation.isValid) {
        this.setState({isDateExpirationValid: true});
      }
    }
  }

  onBlurCardNumberInputInput = () => {
    var numberValidation = valid.number(this.state.CardNumber);

    if (!numberValidation.isPotentiallyValid) {
      this.setState({isCardNumberValid: false});
    }

    if (numberValidation.card) {
      this.setState({isCardNumberValid: true});
      this.setState({userCardType: numberValidation.card.type});
    }
  }

  onBlurCVVInput =() => {
    let cvvValidation = valid.cvv(this.state.CVC);

    if (!cvvValidation.isPotentiallyValid) {

      this.setState({isCvvValid: false});
    }

    if(cvvValidation.isValid)
    {
      this.setState({isCvvValid: true});
    }

  }
  postToken = () => {

    const {orderId, amount, isCreditNote, creditNoteId, isRefund, redirectionURL} = this.props;

    this.props.showSpinner(true)
    let expirationDate = "";

    let cardType = this.state.userCardType;


    if(this.state.userCardType == "maestro") {
      // on va griser l input de cvv
      cardType = "BCMC"
    } else {cardType = "CB_VISA_MASTERCARD"}

    this.props.cardRegistrationForOrganization(this.props.currentClient.id, cardType).then(res => {
      if(res.value.status == 200) {
        if(this.state.dateExpiration.length > 5) {
          expirationDate = moment(this.state.dateExpiration, 'MM/YYYY').format('MMYY')
        } else {
          expirationDate = moment(this.state.dateExpiration, 'MM/YY').format('MMYY')
        }
        // Set MANGOPAY API base URL and Client ID
        mangoPay.cardRegistration.baseURL = server_url;
        mangoPay.cardRegistration.clientId = client_id;

        mangoPay.cardRegistration.init({
          cardRegistrationURL: res.value.data.data[0].CardRegistrationURL,
          preregistrationData: res.value.data.data[0].PreregistrationData,
          accessKey: res.value.data.data[0].AccessKey,
          Id: res.value.data.data[0].Id
        });

        const cardData = {
          cardNumber : this.state.CardNumber,
          cardExpirationDate : expirationDate,
          cardCvx : this.state.CVC,
          cardType: cardType,
        };

        const params = {
          'adressIp' :  this.state.ipAdress,
          'javaEnabled' : window.navigator.javaEnabled(),
          'Language' : window.navigator.language,
          'userAgent' : window.navigator.userAgent,
          'timeZoneOffset' : new Date().getTimezoneOffset(),
          'colorDepth' : screen.colorDepth,
          'screenHeight' : screen.height,
          'screenWidth' : screen.width,

        }

        mangoPay.cardRegistration.registerCard(
          cardData,
          (res) => {
            this.props.FeedMangoWalletForOrganizationPayIn(orderId, amount,res.CardId, !this.state.checkedRegistrCard, params, isCreditNote, creditNoteId, isRefund, redirectionURL, this.props.currentClient.id, this.props.user.id).then(res => {
              if(res.data.data.result == "failed") {
                window.open(res.data.data.redirect_url, "_self")
                this.props.showSpinner(false)
              } else {
                if(res.data.data.secureMode == true) {
                  window.location.assign(res.data.data.redirect_url);
                } else {
                  // lancer le thunk pour le post paiement processing
                  this.props.mangoPayCallbackForOrganization(res.data.data.orderId, res.data.data.transaction_id, res.data.data.deleteCard, creditNoteId, isCreditNote, amount, isRefund, redirectionURL, this.props.user.id).then((res) => {
                    //ajouter unr notif si le peiement est ok avant de faire la redirection
                    if(res.data){
                      window.location.assign(res.data.redirectionUrl);
                    }
                  })
                }

              }
            })
          },
          (res) => {
            this.props.showSpinner(false)
            openNotificationWithIcon('error', _('incompleteOperation'), _('error'))
          }
        );

      }
    })


  }

  onChangeRadio = e => {
    this.setState({
      value: e.target.value,
    });
  };

  onchangeCheckbox = e => {
    this.setState({
      checkedRegistrCard: e.target.checked,
    });

  }

  handleCancelClick = () => {
    this.setState({
      CardNumber: "",
      dateExpiration : "",
      CVC: "",
      isCardNumberValid: true,
      isDateExpirationValid: true,
      isCvvValid: true,
      userCardType: "",
      value: "CB_VISA_MASTERCARD",
      pathImageLogo : "",
    });
  }

  render() {

    return (
      <div className={"card-registration-container " + (this.props.isCommunity ? 'community' : '')}>
        <div className={'card-registration-title mb-4 ' + (this.props.isCommunity ? 'community-theme' : '')}>{_("NEW_BANK_CARD") + ' :'}</div>
        <div className="payment-with-card mb-3">
          <label className="new-card-label">{_("card-Number")}<span className={this.props.isCommunity ? 'new-card-community-star' : 'new-card-label-star'}> *</span></label>
          <Input
            value={this.state.CardNumber}
            onChange={({ target: { value } }) => this.handleCardNumberInputChange(value)}
            className = {this.props.isCommunity ? 'new-community-input' : 'new-card-input'}
            suffix={
              <div>
                {this.state.pathImageLogo !== "" ? <img src={this.state.pathImageLogo} className={'card-img-suffix'} /> : null}
              </div>
            }
            onBlur={this.onBlurCardNumberInputInput}
          />
        </div>
        <Row>
          <Col span={12} className={'pr-2'}>
            <div className="payment-with-card">
              <label className="new-card-label">{_("expiration-Date")}<span className={this.props.isCommunity ? 'new-card-community-star' : 'new-card-label-star'}> *</span></label>
              <Input
                value={this.state.dateExpiration}
                onChange={({ target: { value } }) => this.handleDateExpirationInputChange(value)}
                className = {this.props.isCommunity ? 'community-input' : 'new-input'}
                onBlur={this.onBlurInput}
              />
            </div>
          </Col>
          <Col span={12} className={'pl-2'}>
            <div className="payment-with-card">
              <label className={"new-card-label"}>{_("CVV") }<span className={this.props.isCommunity ? 'new-card-community-star' : 'new-card-label-star'}> *</span></label>
              <Input
                value={this.state.CVC}
                onChange={({ target: { value } }) => this.handleCSVInputChange(value)}
                className = {this.props.isCommunity ? 'community-input' : 'new-input'}
                onBlur={this.onBlurCVVInput}
                disabled={this.state.userCardType == 'maestro'}
              />
            </div>
          </Col>
        </Row>
        <div className="mt-3 flex justify-end mb-4">
          <Checkbox checked={this.state.checkedRegistrCard} onChange={this.onchangeCheckbox}>{_("Enregistrer-et-payer-avec-une-autre-carte")}</Checkbox>
        </div>
        <Row>
          <Col span={12}>
            <button type="button" onClick={this.handleCancelClick} className={'new-card-cancel-button flex items-center ' + (this.state.CVC == "" && this.state.dateExpiration == "" && this.state.CardNumber == "" ? 'user-card-button-not-allowed' : '')} >{_('cancel')}</button>
          </Col>
          <Col span={12} className={'flex justify-end'}>
            <button type="button" onClick={this.postToken} className={'user-card-button card-registration flex items-center ' + (this.props.isCommunity ? 'community-theme ' : '') + (!this.state.isCvvValid || !this.state.isDateExpirationValid || !this.state.isCardNumberValid || (this.state.CVC == "" && this.state.userCardType !== 'maestro') || this.state.dateExpiration == "" || this.state.CardNumber == "" ? 'user-card-button-not-allowed ' : '')}>{_('USE_THIS_CARD')}</button>
          </Col>
        </Row>
      </div>
    )
  }

}

const mapStateToProps = state => ({
  cardRegistration: state.cardRegistration,
  orderLines: state.orderLines,
  currentClient: state.auth.currentClient,
  user: state.auth.user,
});

const mapDispatchToProps = {
  createCardRegistration,
  getToken,
  cardWebPayin,
  showSpinner,
  mangoPayCallback,
  FeedMangoWalletForOrganizationPayIn,
  cardRegistrationForOrganization,
  mangoPayCallbackForOrganization,
};


export default connect(mapStateToProps, mapDispatchToProps)(CardRegistration);



// WEBPACK FOOTER //
// ./app/components/Admin/FeedMangoWallet/CardRegistration.js